var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('press-center',{attrs:{"in-category":1684,"current-url":"Video","in-name":"video"}})}
var staticRenderFns = []

export { render, staticRenderFns }